// Global imperative `window.RedoHsa` surface. The theme app block placeholder
// button calls `window.RedoHsa.open()` to open the questionnaire modal; custom
// Liquid / merchant buttons / Redo's own storefront JS call `goToHsaCheckout`
// or `buyProductNowWithHsa` to send a shopper to standard checkout with the
// HSA/FSA payment method prioritized (see
// `redo/shopify/app/hsa-payment-customization/` and
// REDO_HSA_PAYMENT_PRIORITY_ATTRIBUTE_KEY).
//
// The methods are contributed from two different React islands — `open` from
// the HSA driver island (`driver.tsx`), the checkout methods from the coverage
// manager island (`manager.tsx`) where the buy-now / coverage state lives.
// `registerRedoHsaApi` merges partials so neither island clobbers the other.

// All methods are optional: they're contributed incrementally by separate
// React islands, so at any single registration only some are present. Callers
// (and the Liquid theme block) guard with `window.RedoHsa?.method?.()`.
export interface RedoHsaApi {
  open?: () => void;
  goToHsaCheckout?: () => Promise<void>;
  buyProductNowWithHsa?: (opts?: {
    variantId?: string;
    quantity?: number;
  }) => Promise<void>;
}

declare global {
  interface Window {
    RedoHsa?: RedoHsaApi;
  }
}

// Mutate the existing object in place rather than replacing it, so that any
// merchant/storefront code that captured `window.RedoHsa` before the second
// island registered keeps seeing later-contributed methods (the two islands
// register independently and in unspecified order).
export function registerRedoHsaApi(partial: RedoHsaApi): void {
  if (!window.RedoHsa) {
    window.RedoHsa = {};
  }
  Object.assign(window.RedoHsa, partial);
}
